import React, { useEffect, useState } from 'react';
import FilterPanel from '../../components/ui/FilterPanel';
import Table from '../../components/ui/Table';
import { generateMerchantTransactionSummaryData } from '../../utils/dataGenerators';
const aggregatorOptions = ['Karachi', 'Lahore', 'Islamabad', 'Peshawar', 'Faisalabad'];
const statusOptions = ['All', 'Pending', 'Completed', 'Failed', 'Settled', 'Un-Settled'];
const MerchantTransactionSummary: React.FC = () => {
  // Filter state
  const [selectedAggregators, setSelectedAggregators] = useState<string[]>([]);
  const [fromDate, setFromDate] = useState<string>(() => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date.toISOString().split('T')[0];
  });
  const [toDate, setToDate] = useState<string>(() => new Date().toISOString().split('T')[0]);
  const [status, setStatus] = useState<string>('All');
  // Data state
  const [data, setData] = useState<any[]>([]);
  // Table columns
  const columns = [{
    key: 'merchantId',
    header: 'Merchant ID',
    sortable: true
  }, {
    key: 'merchantName',
    header: 'Merchant Name',
    sortable: true
  }, {
    key: 'aggregator',
    header: 'Aggregator',
    sortable: true
  }, {
    key: 'period',
    header: 'Period',
    sortable: true
  }, {
    key: 'totalTransactions',
    header: 'Total Transactions',
    sortable: true
  }, {
    key: 'completedTransactions',
    header: 'Completed',
    sortable: true
  }, {
    key: 'failedTransactions',
    header: 'Failed',
    sortable: true
  }, {
    key: 'pendingTransactions',
    header: 'Pending',
    sortable: true
  }, {
    key: 'totalAmount',
    header: 'Total Amount (PKR)',
    sortable: true
  }, {
    key: 'successRate',
    header: 'Success Rate',
    sortable: true
  }];
  // Handle filter changes
  const handleAggregatorChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const options = e.target.options;
    const selectedValues = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selectedValues.push(options[i].value);
      }
    }
    setSelectedAggregators(selectedValues);
  };
  const handleApplyFilters = () => {
    const aggregators = selectedAggregators.length > 0 ? selectedAggregators : aggregatorOptions;
    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);
    const filteredData = generateMerchantTransactionSummaryData(aggregators, fromDateObj, toDateObj, status);
    setData(filteredData);
  };
  const handleResetFilters = () => {
    setSelectedAggregators([]);
    const date = new Date();
    setFromDate(new Date(date.setMonth(date.getMonth() - 1)).toISOString().split('T')[0]);
    setToDate(new Date().toISOString().split('T')[0]);
    setStatus('All');
  };
  // Handle export
  const handleExport = (type: 'xlsx' | 'csv' | 'pdf') => {
    // In a real app, this would trigger an actual export
    alert(`Exporting data as ${type.toUpperCase()}`);
  };
  // Initialize data on component mount
  useEffect(() => {
    handleApplyFilters();
  }, []);
  return <div data-id="element-691">
      <div className="flex items-center justify-between mb-6" data-id="element-692">
        <h1 className="text-2xl font-semibold text-gray-800" data-id="element-693">
          Merchant Transaction Summary Report
        </h1>
      </div>
      <FilterPanel title="Filter Options" onApplyFilters={handleApplyFilters} onResetFilters={handleResetFilters} data-id="element-694">
        <div data-id="element-695">
          <label htmlFor="aggregator" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-696">
            Aggregator
          </label>
          <select id="aggregator" multiple value={selectedAggregators} onChange={handleAggregatorChange} className="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" size={5} data-id="element-697">
            {aggregatorOptions.map(option => <option key={option} value={option} data-id="element-698">
                {option}
              </option>)}
          </select>
          <p className="mt-1 text-xs text-gray-500" data-id="element-699">
            Hold Ctrl/Cmd to select multiple
          </p>
        </div>
        <div data-id="element-700">
          <label htmlFor="fromDate" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-701">
            From Date
          </label>
          <input type="date" id="fromDate" value={fromDate} onChange={e => setFromDate(e.target.value)} className="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-702" />
        </div>
        <div data-id="element-703">
          <label htmlFor="toDate" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-704">
            To Date
          </label>
          <input type="date" id="toDate" value={toDate} onChange={e => setToDate(e.target.value)} className="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-705" />
        </div>
        <div data-id="element-706">
          <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-707">
            Transaction Status
          </label>
          <select id="status" value={status} onChange={e => setStatus(e.target.value)} className="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-708">
            {statusOptions.map(option => <option key={option} value={option} data-id="element-709">
                {option}
              </option>)}
          </select>
        </div>
      </FilterPanel>
      <Table columns={columns} data={data} onExport={handleExport} data-id="element-710" />
    </div>;
};
export default MerchantTransactionSummary;